(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tallah-subcollections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealCurrentPills = (root = document) => {
      root.querySelectorAll('.tallah-subcollections__pills').forEach((list) => {
        const current = list.querySelector('a[aria-current="page"]');
        if (!current || list.clientWidth === 0 || list.scrollWidth <= list.clientWidth) return;

        const listBounds = list.getBoundingClientRect();
        const currentBounds = current.getBoundingClientRect();
        const left = listBounds.left + list.clientLeft + 4;
        const right = listBounds.left + list.clientLeft + list.clientWidth - 4;
        let offset = 0;

        if (currentBounds.left < left) {
          offset = currentBounds.left - left;
        } else if (currentBounds.right > right) {
          offset = currentBounds.right - right;
        }

        if (offset) list.scrollBy({ left: offset, behavior: 'instant' });
      });
    };

    const revealWhenReady = (root = document) => {
      requestAnimationFrame(() => revealCurrentPills(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealWhenReady(), { once: true });
    } else {
      revealWhenReady();
    }

    if (document.fonts) document.fonts.ready.then(() => revealWhenReady());
    window.addEventListener('pageshow', () => revealWhenReady());
    document.addEventListener('shopify:section:load', (event) => revealWhenReady(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
